import { pickBy } from "lodash-es"
import type { AlgoliaIndexName } from "~/providers/ConfigProvider"
import { resolveLocationRouteSlug } from "~/helpers/location"

export const searchDefaultIndex: AlgoliaIndexName = "capsulePages"

export const searchPath = (): string => "/search"

export const searchQueryParams = (
  indexName: string,
  query: string,
  page: number
): { [key: string]: string } =>
  removeEmptyParams({
    index: indexName == searchDefaultIndex ? "" : indexName,
    query,
    page: page == 1 ? "" : page.toString()
  })

export const locationPath = (slug: string) => `/locations/${slug}`

export const activityPath = (
  activityTypeSlug: string,
  locationOrOpts?: string | { activityId?: string; locationSlug?: string },
  legacyActivityId?: string
) => {
  const opts =
    typeof locationOrOpts === "string"
      ? { locationSlug: locationOrOpts, activityId: legacyActivityId }
      : locationOrOpts

  const routeLocationSlug = opts?.locationSlug
    ? resolveLocationRouteSlug(opts.locationSlug)
    : undefined
  const base = routeLocationSlug
    ? `/${routeLocationSlug}/activities/${activityTypeSlug}`
    : `/activities/${activityTypeSlug}`

  return opts?.activityId
    ? `${base}?default_activity_id=${opts.activityId}`
    : base
}

export const activityBookingPath = (
  locationSlug: string,
  activityTypeSlug: string,
  step: "schedule" | "tickets"
) => `/${locationSlug}/activities/${activityTypeSlug}/booking/${step}`

export const shopPath = () => "/shop"

export const collectionPath = (handle: string) => `/shop/${handle}`

export const capsulePagePath = (slug: string) => `/${slug}`

export const productPath = (handle: string, collectionHandle?: string) =>
  collectionHandle
    ? `/products/${handle}?collection=${collectionHandle}`
    : `/products/${handle}`

const removeEmptyParams = (params: { [key: string]: string }) =>
  pickBy(params, Boolean)
